export class RequestExecutionRightsNotice {
    constructor(senderId, callbackId) {
        this.type = "requestExecutionRights";
        this.senderId = senderId;
        this.callbackId = callbackId;
    }
    static getType() {
        return "requestExecutionRights";
    }
}
